import { types as t } from 'mobx-state-tree';
import omit from 'lodash/omit';

export default (store) =>
  t.snapshotProcessor(store, {
    postProcessor(sn) {
      return omit(sn, ['nodes']);
    }
  });
